import React from 'react'
import PropTypes from 'prop-types'
import { Table } from 'reactstrap'
import styled from 'styled-components'
import get from 'lodash/get'
import orderBy from 'lodash/orderBy'
import shortid from 'shortid'
import NumberFormat from 'react-number-format'
import arrow_down from '../../../static/images/arrow-down.svg'
import arrow_up from '../../../static/images/arrow-up.svg'
import { subconstract_cost_header_table } from '../constants'
import { statusColor } from '../helpers/color'
import { FONTS, COLORS } from '../../../constants'

export default class SubcontractCostTable extends React.Component {
  state={ sort_order: false, sort_column: 0 }

  handleClickSort(column) {
    if (column === this.state.sort_column) {
      this.setState({
        sort_order: !this.state.sort_order,
      })
    } else {
      this.setState({
        sort_order: false,
        sort_column: column,
      })
    }
  }

  filterSubcontractReport = (compensateReport, searchSubcontract) => {
    return compensateReport.filter(item => {
      const emp_code = get(item, 'emp_code', '').toLowerCase()
      const period = get(item, 'period', '').toLowerCase()
      const name = get(item, 'name', '').toLowerCase()
      const project = get(item, 'project', '').toLowerCase()
      const search = searchSubcontract.toLowerCase()
      return period.includes(search) || emp_code.includes(search) || name.includes(search)
        || project.includes(search)
    })
  }

  sortSubcontractWork = (data) => {
    const { sort_column } = this.state
    const sort_order = this.state.sort_order ? 'asc' : 'desc'
    if (sort_column === 0) return orderBy(data, 'emp_code', sort_order)
    else if (sort_column === 1) return orderBy(data, 'name', sort_order)
    else if (sort_column === 2) return orderBy(data, 'period', sort_order)
    else if (sort_column === 3) return orderBy(data, 'project', sort_order)
    else if (sort_column === 4) return orderBy(data, 'days', sort_order)
    else if (sort_column === 5) return orderBy(data, 'rate', sort_order)
    else if (sort_column === 6) return orderBy(data, 'cost', sort_order)
    else if (sort_column === 7) {
      return orderBy(data, (item) => {
        const order = {
          'APPROVED': 1,
          'PENDING': 2,
          'CANCEL': 3,
          'REJECTED': 4,
        }
        return order[item.status]
      }, sort_order)
    }
    return data
  }

  render() {
    const { sort_order, sort_column } = this.state
    const { searchSubcontract } = this.props
    let subContractCosts = get(this.props, 'subContractCosts', [])
    subContractCosts = this.filterSubcontractReport(subContractCosts, searchSubcontract)

    return (
    /* eslint no-underscore-dangle: 0 */
      <Wrapper>
        <NewTable bordered hover>
          <Header>
            <tr>
              {
                subconstract_cost_header_table.map((h) =>
                  (<HeadTable key={ shortid() } onClick={ () => this.handleClickSort(h.value) } >
                    { h.label }
                    { h.value === sort_column && (
                      sort_order && h.value === sort_column ?
                        <Icon src={ arrow_up } alt="logo" />
                        :
                        <Icon src={ arrow_down } alt="logo" />
                    )
                    }</HeadTable>)
                )}
            </tr>
          </Header>
          <BodyTable>
            {
              this.sortSubcontractWork(subContractCosts).map(report => {
                return (<tr
                  key={ shortid() }
                  style={ {
                    cursor: 'pointer',
                    hover: '#E5E5E5',
                  } }
                  onClick={ () => this.props.handleClickRow(report._id, report) }
                >
                  <td style={ { color: statusColor(report.status) } }>
                    <div
                      style={ {
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        color: statusColor(report.status),
                      } }
                    >
                      <Circle color={ statusColor(report.status) } />
                      { report.status }
                    </div>
                  </td>
                  <td>{ report.emp_code }</td>
                  <td>{ report.name }</td>
                  <td>{ report.period }</td>
                  <td>{ report.project }</td>
                  <td>{ report.days }</td>
                  <td style={ { textAlign: 'right' } }>{
                    <NumberFormat
                      thousandSeparator={ true }
                      decimalScale={ 2 }
                      fixedDecimalScale={ true }
                      displayType='text'
                      value={ report.rate }
                    />
                  }</td>
                  <td style={ { textAlign: 'right' } }>{
                    <NumberFormat
                      thousandSeparator={ true }
                      decimalScale={ 2 }
                      fixedDecimalScale={ true }
                      displayType='text'
                      value={ report.cost }
                    />
                  }</td>
                </tr>)
              }
              )}
          </BodyTable>
        </NewTable>
      </Wrapper>
    )
  }
}

SubcontractCostTable.propTypes = {
  handleClickRow: PropTypes.func,
  searchSubcontract: PropTypes.string,
}
SubcontractCostTable.defaultProps = {
  handleClickRow: () => {},
  searchSubcontract: '',
}

const Wrapper = styled.div`
  margin-left: 10px;
  margin-right: 10px;
`
const NewTable = styled(Table)`
  background: white;
  thead {
    display: table;
    width: 100%;
    table-layout: fixed;
  } tbody tr {
    display: table;
    width: 100%;
    table-layout: fixed;
    font-family: ${FONTS.GOTHAM} !important;
    font-size: ${FONTS.SMALL_SIZE};
    border: none;
  } thead th {
    border: 1px solid #dee2e6;
    font-size: ${FONTS.SMALL_SIZE};
  } tbody td {
    border: 1px solid #dee2e6;
    font-size: ${FONTS.SMALL_SIZE};
    word-wrap: break-word;
  }
`
const BodyTable = styled.tbody`
  width: 100%;
  display: block;
  max-height: calc(100vh - 200px);
  overflow-y:scroll;
  ::-webkit-scrollbar {
    display: none;
  }
`
const HeadTable = styled.th`
  color: white;
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  cursor: pointer;
`
const Icon = styled.img`
  height: 10px;
  margin-left: 5%;
  cursor: pointer;
`
const Header = styled.thead`
  background: ${COLORS.TABLE_HEADER_COLOR};
`
const Circle = styled.div`
  height: 8px;
  width: 8px;
  background-color: ${(props) => props.color};
  border-radius: 50%;
  margin-right: 5px;
  margin-bottom: auto;
  margin-top: auto;
`



// WEBPACK FOOTER //
// ./src/components/report/table/subcontract-cost.js